import * as React from 'react';
import * as getCourse from './sellingBlockModules.module.scss';
import { Modal } from '../../../../Modal';
import { TaxDeduction } from "../../../../TaxDeduction";

export const SellingBlockModules = ({ title, description, price, buttonText, hiddenBtn, widget1, widget2, anchor, bottomText=false, free=false }) => {
  const [showModal1, setShowModal1] = React.useState(false);
  const [showModal2, setShowModal2] = React.useState(false);

  return (
    <section className={getCourse.getCourse} id={anchor}>
      <div className={`container ${getCourse.getCourse__container}`}>
        <h5 className={getCourse.getCourse__title}>{title}</h5>
        <div className={getCourse.getCourse__window}>
          <div className={getCourse.getCourse__text}>
            <p className={getCourse.getCourse__name}>{description}</p>
            <p className={getCourse.getCourse__number}>{price}</p>
          </div>
          <div className={getCourse.getCourse__buttons}>
            <button
              className={`${getCourse.main__btn} ${getCourse.buy__btn}`}
              onClick={() => {
                setShowModal1(true);
              }}
            >
              {buttonText}
            </button>
            {hiddenBtn ? null : (
              <button
                className={`${getCourse.main__btn} ${getCourse.get__btn}`}
                onClick={() => {
                  setShowModal2(true);
                }}
              >
                Получить консультацию менеджера
              </button>
            )}
          </div>
          {
            !bottomText ?
              null
              :
              (<p className={getCourse.getCourse__writeoff}>
                Списание проходит автоматически, за сутки до оплаты вы получите уведомление.
              </p>)
          }
          { !free && <TaxDeduction className={getCourse.getCourse__writeoff}/>}
        </div>
      </div>

      <Modal
        open={showModal1}
        onClose={() => {
          setShowModal1(false);
        }}
      >
        {widget1}
      </Modal>

      <Modal
        open={showModal2}
        onClose={() => {
          setShowModal2(false);
        }}
      >
        {widget2}
      </Modal>
    </section>
  );
};
